import { CardBase, FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const TopCard = styled(CardBase)`
  height: 29rem;
`;

export const DataContainer = styled(FlexContainer)`
  padding: 1.7rem 2rem;
`;

export const RowContainer = styled(FlexContainer)`
  height: 3.2rem;
  padding: 0.8rem;
  border-bottom: 0.1rem solid rgba(204, 212, 229, 1);
`;
